module.exports = __webpack_public_path__ + "img/downApp.c611372a.png";